import React from 'react'
import { withRouter } from 'react-router'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Manager, Target, Popper } from 'react-popper'
import { Query } from 'react-apollo'
import moment from 'moment'

import miniMe from 'graphql/queries/miniMe'
import appuntamentiPerStato from 'graphql/queries/appuntamentiPerStato'
import clienti from 'graphql/queries/clienti'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import MenuItem from 'material-ui/Menu/MenuItem'
import MenuList from 'material-ui/Menu/MenuList'
import ClickAwayListener from 'material-ui/utils/ClickAwayListener'
import Paper from 'material-ui/Paper'
import Grow from 'material-ui/transitions/Grow'
import IconButton from 'material-ui/IconButton'
import Hidden from 'material-ui/Hidden'

// material-ui-icons
// import Person from 'material-ui-icons/Person'
import Notifications from 'material-ui-icons/Notifications'
import DateRange from 'material-ui-icons/DateRange'
// import Search from 'material-ui-icons/Search'

// core components
// import CustomInput from 'components/CustomInput/CustomInput.jsx'
// import SearchButton from 'components/CustomButtons/IconButton.jsx'

import headerLinksStyle from 'assets/jss/material-dashboard-pro-react/components/headerLinksStyle'
import 'react-toastify/dist/ReactToastify.min.css'


class HeaderLinks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openAppuntamenti: false,
      open: false
    }
  }

  handleClick = () => {
    this.setState({ 
      open: !this.state.open 
    })
  }

  handleClickAppuntamenti = () => {
    this.setState({
      openAppuntamenti: !this.state.openAppuntamenti 
    })
  }

  handleLink = clienteId => event => {
    this.setState({ 
      open: !this.state.open 
    })
    if (!!clienteId) {
      this.props.history.push(`/clienti/${clienteId}`)
    }
  }

  handleLinkAppuntamenti = clienteId => event => {
    this.setState({ 
      openAppuntamenti: !this.state.openAppuntamenti 
    })
    if (!!clienteId) {
      this.props.history.push(`/clienti/${clienteId}`)
    }
  }

  handleClose = () => {
    this.setState({ 
      open: false 
    })
  }

  handleCloseAppuntamenti = () => {
    this.setState({ 
      openAppuntamenti: false 
    })
  }


  render() {
    const { classes } = this.props
    const { open, openAppuntamenti } = this.state

    // const searchButton =
    //   classes.top +
    //   " " +
    //   classes.searchButton

    const dropdownItem = classes.dropdownItem

    const wrapper = classes.wrapperRTL

    const managerClasses = classNames({
      [classes.managerClasses]: true
    })


    return (
      <div className={wrapper}>
        {/* <CustomInput
          formControlProps={{
            className: classes.top + " " + classes.search
          }}
          inputProps={{
            placeholder: "Cerca",
            inputProps: {
              "aria-label": "Cerca",
              className: classes.searchInput
            }
          }}
        />
        <SearchButton
          color="white"
          aria-label="edit"
          customClass={searchButton}
        >
          <Search className={classes.searchIcon} />
        </SearchButton> */}

        <Query query={miniMe}>
          {({ loading, error, data: { me } }) => {
            if (loading) return <p>Loading...</p>
            if (error) return <p>Error :(</p>
            
            return (
              (me.ruolo === 'ADMIN' || me.ruolo === 'SEGRETARIA') && (
                <Query
                  query={appuntamentiPerStato}
                  variables={{
                    limit: 5,
                    stato: 'FISSATO_AGENTE',
                    daData: moment().subtract(10, 'days').format('YYYY-MM-DD'),
                    aData: moment().add(100, 'days').format('YYYY-MM-DD')
                  }}
                  fetchPolicy="cache-and-network"
                  pollInterval={30000}
                >
                  {({ loading, error, data }) => {
                    if (loading) return (
                      <Manager className={managerClasses}>
                        <Target>
                          <IconButton
                            color="inherit"
                            aria-label="Notifiche appuntamenti"
                            aria-owns={openAppuntamenti ? "menu-list" : null}
                            aria-haspopup="true"
                            onClick={this.handleClickAppuntamenti}
                            className={classes.buttonLink}
                            classes={{
                              label: ""
                            }}
                          >
                            <DateRange className={classes.links} />
                            <span className={classes.notifications}>{}</span>
                            <Hidden mdUp>
                              <p onClick={this.handleClickAppuntamenti} className={classes.linkText}>Notifiche app. da fissare</p>
                            </Hidden>
                          </IconButton>
                        </Target>
                      </Manager>
                    )
                    if (error) return <p>Error :(</p>
                    
                    return (
                      <ClickAwayListener onClickAway={this.handleCloseAppuntamenti}>
                        <Manager className={managerClasses}>
                          <Target>
                            <IconButton
                              color="inherit"
                              aria-label="Notifiche appuntamenti"
                              aria-owns={openAppuntamenti ? "menu-list" : null}
                              aria-haspopup="true"
                              onClick={this.handleClickAppuntamenti}
                              className={classes.buttonLink}
                              classes={{
                                label: ""
                              }}
                            >
                              <DateRange className={classes.links} />
                              <span className={classes.notifications}>{data.azioni.totalCount}</span>
                              <Hidden mdUp>
                                <p onClick={this.handleClickAppuntamenti} className={classes.linkText}>Notifiche app. da fissare</p>
                              </Hidden>
                            </IconButton>
                          </Target>
                          <Popper
                            placement="bottom-start"
                            eventsEnabled={openAppuntamenti}
                            className={
                              classNames({ [classes.popperClose]: !openAppuntamenti }) +
                              " " +
                              classes.pooperResponsive
                            }
                          >
                            <Grow
                              in={openAppuntamenti}
                              id="menu-list"
                              style={{ transformOrigin: "0 0 0" }}
                            >
                              <Paper className={classes.dropdown}>
                                <MenuList role="menu">
                                  {data.azioni.totalCount === 0 ?
                                    <MenuItem
                                      onClick={this.handleCloseAppuntamenti}
                                      className={dropdownItem}
                                    >
                                      Nessun appuntamento da confermare
                                    </MenuItem>
                                  :
                                    data.azioni.nodes.map(azione => {
                                      return (
                                        <MenuItem
                                          onClick={this.handleLinkAppuntamenti(azione.cliente.id)}
                                          className={dropdownItem}
                                          key={azione.id}
                                        >
                                          Appuntamento con {azione.cliente.nome}
                                        </MenuItem>
                                      )
                                    })
                                  }
                                </MenuList>
                              </Paper>
                            </Grow>
                          </Popper>
                        </Manager>
                      </ClickAwayListener>
                    )
                  }}
                </Query>
              )
            )
          }}
        </Query>

        <Query
          query={clienti}
          variables={{
            limit: 5,
            offset: 0,
            where: {
              daRicontattare: true,
              telNonRisposte: 0,
            },
            orderBy: ["dataUltimaRichiesta_DESC"]
          }}
          fetchPolicy="cache-and-network"
          pollInterval={30000}
        >
          {({ loading, error, data }) => {
            if (loading) return (
              <IconButton
                color="inherit"
                aria-label="Notifiche"
                aria-owns={open ? "menu-list" : null}
                aria-haspopup="true"
                onClick={this.handleClick}
                className={classes.buttonLink}
                classes={{
                  label: ""
                }}
              >
                <Notifications className={classes.links} />
                <span className={classes.notifications}>{}</span>
                <Hidden mdUp>
                  <p onClick={this.handleClickAppuntamenti} className={classes.linkText}>Notifiche appuntamenti da fissare</p>
                </Hidden>
              </IconButton>
            )
            if (error) return <p>Error :(</p>
            
            return (
              <ClickAwayListener onClickAway={this.handleClose}>
                <Manager className={managerClasses}>
                  <Target>
                    <IconButton
                      color="inherit"
                      aria-label="Notifiche"
                      aria-owns={open ? "menu-list" : null}
                      aria-haspopup="true"
                      onClick={this.handleClick}
                      className={classes.buttonLink}
                      classes={{
                        label: ""
                      }}
                    >
                      <Notifications className={classes.links} />
                      <span className={classes.notifications}>{data.clienti.totalCount}</span>
                      <Hidden mdUp>
                        <p onClick={this.handleClick} className={classes.linkText}>Notifiche</p>
                      </Hidden>
                    </IconButton>
                  </Target>
                  <Popper
                    placement="bottom-start"
                    eventsEnabled={open}
                    className={
                      classNames({ [classes.popperClose]: !open }) +
                      " " +
                      classes.pooperResponsive
                    }
                  >
                    <Grow
                      in={open}
                      id="menu-list"
                      style={{ transformOrigin: "0 0 0" }}
                    >
                      <Paper className={classes.dropdown}>
                        <MenuList role="menu">
                          {data.clienti.totalCount === 0 ?
                            <MenuItem
                              onClick={this.handleClose}
                              className={dropdownItem}
                            >
                              Nessun cliente da ricontattare
                            </MenuItem>
                          :
                            data.clienti.nodes.map(cliente => {
                              return (
                                <MenuItem
                                  onClick={this.handleLink(cliente.id)}
                                  className={dropdownItem}
                                  key={cliente.id}
                                >
                                  Ricontattare {cliente.nome}
                                </MenuItem>
                              )
                            })
                          }
                        </MenuList>
                      </Paper>
                    </Grow>
                  </Popper>
                </Manager>
              </ClickAwayListener>
            )
          }}
        </Query>
        
        {/* <IconButton
          color="inherit"
          aria-label="Person"
          className={classes.buttonLink}
          classes={{
            label: ""
          }}
        >
          <Person className={classes.links} />
          <Hidden mdUp>
            <p className={classes.linkText}>Profilo</p>
          </Hidden>
        </IconButton> */}
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired
}

HeaderLinks = withRouter(HeaderLinks)
export default withStyles(headerLinksStyle)(HeaderLinks)



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx